var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.hasEntryGenre, function(category) {
      return _c(
        "div",
        { key: category.id, staticClass: "v-allergy-list-block" },
        [
          _c("h2", { staticClass: "p-hdg-bottomline -large -noborder" }, [
            _vm._v(_vm._s(category.name))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "allergy-table" }, [
            _c("table", { staticClass: "p-table-normal" }, [
              _vm._m(0, true),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.allergyList[category.id], function(item) {
                  return _c(
                    "tr",
                    { key: item.id, attrs: { id: "d" + item.id } },
                    [
                      _c("td", [_vm._v(_vm._s(item.title))]),
                      _vm._v(" "),
                      _c("td", [
                        item.allergy.egg !== undefined
                          ? _c("span", [_vm._v("◯")])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        item.allergy.milk !== undefined
                          ? _c("span", [_vm._v("◯")])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        item.allergy.wheat !== undefined
                          ? _c("span", [_vm._v("◯")])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        item.allergy.buckwheat !== undefined
                          ? _c("span", [_vm._v("◯")])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        item.allergy.peanut !== undefined
                          ? _c("span", [_vm._v("◯")])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        item.allergy.shrimp !== undefined
                          ? _c("span", [_vm._v("◯")])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        item.allergy.crab !== undefined
                          ? _c("span", [_vm._v("◯")])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("td", [_vm._v(_vm._s(item.remarks))])
                    ]
                  )
                }),
                0
              )
            ])
          ])
        ]
      )
    }),
    0
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("商品名")]),
        _vm._v(" "),
        _c("th", [_vm._v("卵")]),
        _vm._v(" "),
        _c("th", [_vm._v("乳")]),
        _vm._v(" "),
        _c("th", [_vm._v("小麦")]),
        _vm._v(" "),
        _c("th", [_vm._v("そば")]),
        _vm._v(" "),
        _c("th", [_vm._v("落花生")]),
        _vm._v(" "),
        _c("th", [_vm._v("えび")]),
        _vm._v(" "),
        _c("th", [_vm._v("かに")]),
        _vm._v(" "),
        _c("th", [_vm._v("備考")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }